var _path, _circle, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocChargeTransactionOnDate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 63,
    viewBox: "0 0 60 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29062 24.75L9.24375 16.4167C10.425 13.1667 13.4625 11 16.9219 11H32.1937C35.6531 11 38.6906 13.1667 39.8719 16.4167L42.7406 24.5C35.4844 25.5 30 31.6667 30 39C30 39.9167 30 40.8333 30.1687 41.6667H12V45.3333C12 46.8333 10.7344 48 9.3 48H5.7C4.18125 48 3 46.8333 3 45.3333V29.6667C3 27.5 4.35 25.5833 6.29062 24.75Z",
    fill: "#03E8AF",
    fillOpacity: 0.1,
    stroke: "#1EF5DF",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 40,
    r: 11,
    fill: "#03A3E8",
    fillOpacity: 0.1,
    stroke: "#87FF0B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40.6818L47.0714 33V38.3182H51L44.9286 46V40.6818H41Z",
    fill: "#87FF0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30H16C18.2091 30 20 31.7909 20 34V34",
    stroke: "#87FF0B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37 24H12L14.2184 17.8333C14.5597 16.75 15.5836 16 16.7782 16H32.2218C33.4164 16 34.4403 16.75 34.7816 17.8333L37 24Z",
    fill: "#1EF5DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocChargeTransactionOnDate);
export default __webpack_public_path__ + "static/media/ic_soc_charge_transaction_on_date.1389a34ed27df5b17af985124bf8e4b0.svg";
export { ForwardRef as ReactComponent };